import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  selectQuestions,
  selectQuestionPagination,
  selectQuestionFilter,
  fetchQuestionsActions,
  setQuestionsFilterAction,
  fetchQuestionCountActions,

} from '../ducks'
import { push } from 'react-router-redux';
import { QuestionList } from '../components';
import { apiCallIds as questionApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { helpStatus } from '../../../common/enums';
import { selectToken } from '../../auth/ducks';

  const mapStateToProps = state => ({

    questions: selectQuestions(state),
    pagination: selectQuestionPagination(state),
    filter: selectQuestionFilter(state),
    token: selectToken(state),
    isLoading: selectIsInProgress(state, questionApiCallIds.FETCH_QUESTIONS),
    

  });

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchQuestions: fetchQuestionsActions.request,
      fetchQuestionCount: fetchQuestionCountActions.request,
      setFilter: setQuestionsFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
  id_status: helpStatus.NEZODPOVEDANA,
};


@connect(mapStateToProps, mapDispatchToProps)
export default class QuestionsContainer extends Component {

  static propTypes = {
    actions: PropTypes.object.isRequired,
    questions: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter)
    actions.fetchQuestions(defaultFilter)
    
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { actions, filter } = this.props;
    actions.fetchQuestions({
      ...filter,
      pageNo: pagination.current -1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { filter, actions } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };

  onFilterStatusChange = this.onFilterChange('id_status');


  render() {

    const { questions, pagination, filter, isLoading, t, token, } = this.props;

   
    return (
      <div id="loanstablediv">
        <h1>Otázky</h1>
          <QuestionList
            questions={questions}
            pagination={pagination}
            filter={filter}
            onTableChange={this.handleTableChange}
            onFilterStatusChange={this.onFilterStatusChange}
            isLoading={isLoading}
            token={token}
          />

      </div>
    );

  }

}





// WEBPACK FOOTER //
// ./src/features/help-management/containers/QuestionsContainer.js